/**
 * Side Panel Constants
 *
 * These constants are used by the SidePanel components.
 * Some values are also re-exported from contexts/sidePanels for consistency.
 */

import { TOOLBAR_COLORS } from "components/toolbars/constants";

// Re-export from contexts for consistency
export { PANEL_WIDTH, PANEL_GAP, MAX_OPEN_PANELS, PANEL_ANIMATION_DURATION } from "contexts/sidePanels/constants";

// Layout margins (relative to other UI elements)
export const SIDE_PANEL_LAYOUT = {
    /** Margin from top (accounts for TopBar + 12px padding) */
    TOP_MARGIN: 76,
    /** Margin from bottom (accounts for BottomToolbar) */
    BOTTOM_MARGIN: 80,
    /** Margin from right edge (12px padding) */
    RIGHT_MARGIN: 12,
} as const;

// Colors
export const SIDE_PANEL_COLORS = {
    /** Panel background */
    BG: TOOLBAR_COLORS.WHITE,
    /** Header background - white to blend with main window */
    HEADER_BG: TOOLBAR_COLORS.WHITE,
    /** Border color */
    BORDER: TOOLBAR_COLORS.BORDER,
    /** Text color */
    TEXT: TOOLBAR_COLORS.DEFAULT,
    /** Icon color */
    ICON: TOOLBAR_COLORS.DEFAULT,
    /** Button background */
    BUTTON_BG: TOOLBAR_COLORS.HOVER,
    /** Default text */
    DEFAULT: TOOLBAR_COLORS.DEFAULT,
} as const;

// Z-index
export const SIDE_PANEL_Z_INDEX = 1070;
